import { render, staticRenderFns } from "./MiniCart.vue?vue&type=template&id=c96635b2&scoped=true&"
import script from "./MiniCart.vue?vue&type=script&lang=js&"
export * from "./MiniCart.vue?vue&type=script&lang=js&"
import style0 from "./MiniCart.vue?vue&type=style&index=0&id=c96635b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c96635b2",
  null
  
)

export default component.exports